<template>
    <div>
        <template v-if="summary?.venta">
            <div>
                <div class="text-caption">
                    {{ caption }}
                </div>
                <v-chip label small class="mr-2">Ventas: {{ summary.venta | currency(summary.divisa_code) }}</v-chip>
                <v-chip label small class="mr-2">Comisión: {{ summary.comision | currency(summary.divisa_code) }}</v-chip>
                <v-chip label small class="mr-2">Premios: {{ summary.premio | currency(summary.divisa_code) }}</v-chip>
                <v-chip label small :color="totalColor">Total: {{ summary.total | currency(summary.divisa_code) }}</v-chip>
            </div>
        </template>
    </div>
</template>

<script>
export default {
    props: {
        loading: {
            default: false,
        },
        caption: {
            type: String,
            required: true,
        },
        summary: {
            defaults: function() {
                return {};
            },
        }
    },
    computed: {
        totalColor: function () {
            let color = 'secondary';
            if (!this.summary?.total) return color;
            if (this.summary?.total > 0) return 'primary';
            return 'error';
        }
    }
}
</script>
<style>

</style>